const PinTack = (
    <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
    >
        <path d="m9 16.25v-4" />
        <path d="m14.25 12.25c-.089-.699-.318-1.76-.969-2.875-.335-.574-.703-1.028-1.031-1.375v-4.25c0-1.105-.895-2-2-2h-2.5c-1.105 0-2 .895-2 2v4.25c-.329.347-.697.801-1.031 1.375-.65 1.115-.88 2.176-.969 2.875z" />
    </g>
);

export { PinTack };
